export default __webpack_public_path__ + "static/media/Close.918591ce.svg";